// extracted by mini-css-extract-plugin
export var backgroundImage = "FeaturesSection-module--backgroundImage--2f21f";
export var content = "FeaturesSection-module--content--5381b";
export var innerWrapper = "FeaturesSection-module--innerWrapper--e6d67";
export var media = "FeaturesSection-module--media--6f795";
export var wrapper = "FeaturesSection-module--wrapper--b9ae7";